import { ComponentProps, ComponentType } from 'react'
import styled from '@emotion/styled'
import { Button } from 'antd'

export type CommonButtonType = 'outline' | 'filled' | 'danger'

type ButtonPropsWithoutType = Omit<ComponentProps<typeof Button>, 'type'>

export const CommonButton = styled(
  Button as ComponentType<ButtonPropsWithoutType>,
  {
    shouldForwardProp: (prop) => prop !== 'type'
  }
)<{ type?: CommonButtonType }>(({ type = 'outline' }) => {
  const backgroundColor =
    type === 'danger'
      ? '#a40000'
      : type === 'filled'
      ? '#4A4A68'
      : 'transparent'
  const color =
    type === 'danger' ? '#fff' : type === 'filled' ? '#FFFFFF' : '#4A4A68'
  const borderColor = type === 'danger' ? '#a40000' : '#4a4a68'

  return `
    background-color: ${backgroundColor};
    color: ${color};
    border-color: ${borderColor};

    justify-content: center;

    &:hover,
    &:focus,
    &:active {
      background-color: ${backgroundColor};
      color: ${color};
      border-color: ${borderColor};
    }
  `
})
